import React from 'react';
import List from '../../../../ui/organisms/List';
import CreatorCardContainer from '../../../CreatorCard';
import config from '../../../../../config.json';

const { routes } = config;

type ParsedCreator = {
  id: string;
  handle: string;
  title: string;
  imageSrc: string;
};

type FeaturedCreatorsListViewProps = {
  creators: ParsedCreator[];
  onViewAllClick: () => void;
};

const FeaturedCreatorsListView: React.FC<FeaturedCreatorsListViewProps> = ({ creators, onViewAllClick }) => (
  <div className="mt-10 mb-10">
    <List
      headingSpecs={{
        sectionTitle: 'Featured Creators',
        linkText: 'View All',
        href: routes.featuredCreators,
        onClick: onViewAllClick,
      }}
      cardWidth={{
        mobile: 'w-[100px]',
        sm: 'sm:w-[100px]',
        lg: 'lg:w-[100px]',
      }}
    >
      {creators.map((creator) => (
        <CreatorCardContainer
          key={creator.id}
          fullName={creator.title}
          src={creator.imageSrc}
          href={`/shop/creator/${creator.handle}`}
          collectionHandle={creator.handle}
          sectionName="home_featured_creators"
        />
      ))}
    </List>
  </div>
);

export default FeaturedCreatorsListView;
